import res from './res'

res.add('kk', {
    show: 'ашу',
    hide: 'жабу'
})

